import React, { useLayoutEffect, useState } from 'react';
import styled from 'styled-components';
import LockIcon from '@template/GuardItem/LockIcon';
import Icon from '@components/dataDisplay/Icons/Icon';

import { useMasterPermission, useMemberPermission } from '@hooks/usePermission';
import { ACCESS_TYPE } from '@typings/common/accessType';
import { BOARD_TYPE } from '@typings/boardType';
import { dateAgo } from '@utils/dateAgo';
import extractTextToHtml from '@utils/extractTextToHtml';

const ItemWrapper = styled.div`
  color: var(--textColor);
  padding: 8px 6px ;
  width: 100%;
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 8px;
  transition: all 0.2s;
  font-size: 14px;

  .contents {
    max-width: 100%;
    position: relative;
    line-height: 1.2;
    /* ellipsis */
    max-height: 42px;
    overflow: hidden;
    white-space: normal;
    text-overflow: ellipsis;
    word-wrap: break-word;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    word-break: break-all;
    /* ellipsis end */

    /* &::before {
      content: '✦';
      font-size: 12px;
      position: absolute;
      top: 0;
      left: 0;
    } */
  }

  &:hover {
    cursor: var(--hoverCursorURL), pointer;
    color: var(--primaryColor);

    strong {
      text-decoration: underline;
    }
  }
`;

const TitleWrap = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const InfoSec = styled.div`
  display: flex;
  gap: 4px;
  font-size: 11px;
  color: var(--subTextColor);
  word-break: break-all;
`;

const Dott = styled.div`
  border-top: 2px solid var(--subTextColor);
  border-style: dotted;
  height: 2px;
  min-width: 2px;
`;

type Props = {
  data: any;
  noShowDate?: boolean;
  showEditDate?: boolean;
  icon: any;
};
function DocItem({ data, icon, noShowDate, showEditDate }: Props) {
  const {
    contents,
    title,
    createdAt,
    editedAt,
    accessType,
    boardType,
  } = data;
  const [replaceContents, setReplaceContents] = useState('');

  useLayoutEffect(() => {
    if (boardType === BOARD_TYPE.TIMELINE) {
      setReplaceContents(extractTextToHtml(contents));
    } else {
      setReplaceContents(title);
    }
  }, [data]);

  const memberPermission = useMemberPermission({});
  const masterPermission = useMasterPermission({});

  const AccessMap = {
    [ACCESS_TYPE.PUBLIC]: (
      <strong
        className="contents"
        dangerouslySetInnerHTML={{
          __html: replaceContents,
        }}
      />
    ),
    [ACCESS_TYPE.MEMBER]: memberPermission ? (
      <strong
        className="contents"
        dangerouslySetInnerHTML={{
          __html: replaceContents,
        }}
      />
    ) : null,
    [ACCESS_TYPE.SECRET]: masterPermission ? (
      <>
        <Icon name="Lock14" color={'var(--subTextColor)'} />
        <strong
          className="contents"
          dangerouslySetInnerHTML={{
            __html: replaceContents,
          }}
        />
      </>
    ) : (
      <>
        <Icon name="Lock14" color={'var(--subTextColor)'} />
        <strong className="contents">비공개글</strong>
      </>
    ),
    [ACCESS_TYPE.PASSWORD]: masterPermission ? (
      <>
        <Icon name="Lock14" color={'var(--subTextColor)'} />
        <strong
          className="contents"
          dangerouslySetInnerHTML={{
            __html: replaceContents,
          }}
        />
      </>
    ) : (
      <>
        <Icon name="Lock14" color={'var(--subTextColor)'} />
        <strong className="contents">보호된 게시글</strong>
      </>
    ),
  };

  return (
    <ItemWrapper>
      <TitleWrap>
        <Icon name={icon} />
        {AccessMap[accessType]}
      </TitleWrap>
      {!noShowDate && (
        <>
          <Dott />
          <InfoSec>
            <span>{dateAgo(showEditDate ? editedAt : createdAt, false)}</span>
          </InfoSec>
        </>
      )}
    </ItemWrapper>
  );
}

export default DocItem;
